import { render, staticRenderFns } from "./NovoContatoDialog.vue?vue&type=template&id=505210d4&scoped=true"
import script from "./NovoContatoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NovoContatoDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NovoContatoDialog.vue?vue&type=style&index=0&id=505210d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505210d4",
  null
  
)

export default component.exports